import { FC } from 'react';
import Modal from 'src/common/components/ModalDS22';
import { Trans, useTranslation } from 'next-i18next';
import { PATHS, SUPPORT_URLS } from 'src/common/constants';
import Button from 'src/common/components/ButtonDS22';
import UniversalLink from 'src/common/components/UniversalLink';
import styles from './CommunicationsWarningModal.module.scss';

export type Props = {
  isOpen: boolean;
  handleSubmit: () => void;
  submitting?: boolean;
};

const {
  HeaderDS22: Header,
  BodyDS22: Body,
  FooterDS22: Footer,
} = Modal;

const CommunicationsWarningModal: FC<Props> = ({
  isOpen,
  handleSubmit,
  submitting,
}) => {
  const [t] = useTranslation('common');
  return (
    <Modal
      modalOpen={isOpen}
      closeModal={handleSubmit}
      position="middle"
      label={t('communications-warning--title')}
      shouldCloseOnOverlayClick={false}
    >
      <div className={styles.header}>
        <Header
          title={t('communications-warning--title')}
          titleSize="heading-4"
        />
      </div>
      <Body
        slot1={(
          <div className={styles.content}>
            <p className={styles.copy}>
              <Trans
                t={t}
                i18nKey="communications-warning--description"
                components={[
                  <UniversalLink
                    className={styles.link}
                    href={PATHS.TERMS}
                    openInNewTab
                  />,
                  <UniversalLink
                    className={styles.link}
                    href={SUPPORT_URLS.WHY_COMMUNICATE_AND_PAY_THROUGH_GETMYBOAT}
                    openInNewTab
                  />,
                ]}
              />
            </p>
          </div>
        )}
        spacingBottom="s"
      />
      <Footer
        buttonPrimary={(
          <Button
            onClick={() => handleSubmit()}
            loading={submitting}
          >
            {t('communications-warning--cta')}
          </Button>
        )}
      />
    </Modal>
  );
};

export default CommunicationsWarningModal;
